<template>
  <div>
    <div
      style="
        position: fixed;
        z-index: 99999;
        width: 100%;
        height: 176px;
        background-color: #f2f2f2;
      "
    >
      <headV />
    </div>
    <div
      style="
        width: 100%;
        position: absolute;
        top: 176px;
        background-color: #f2f2f2;
        min-height: calc(100vh - 176px);
        padding-bottom: 60px;
      "
    >
      <div class="resource container">
        <div class="history">
          <div>
            <div class="history-date">
              <ul>
                <h2 class="first"><a href="#nogo">2025年</a></h2>
                <li class="green">
                  <h3>12月<span>2025</span></h3>
                  <dl>
                    <dt>
                      更新了新一代天地图门户网站。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>11月<span>2025</span></h3>
                  <dl>
                    <dt>
                      更新了审图号为“苏B(2025)026号”。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>11月<span>2025</span></h3>
                  <dl>
                    <dt>
                      更新江阴市2025卫星影像数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>8月<span>2025</span></h3>
                  <dl>
                    <dt>
                      更新矢量地图注记、影像地图注记。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>6月<span>2025</span></h3>
                  <dl>
                    <dt>
                      更新了2025年兴趣点（POI）数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo">2024年</a></h2>
                <li class="green">
                  <h3>8月<span>2024</span></h3>
                  <dl>
                    <dt>
                      更新江阴市2024卫星影像数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>

                <li class="green">
                  <h3>4月<span>2024</span></h3>
                  <dl>
                    <dt>
                      更新江阴高铁站影像和矢量地图数据
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>2月<span>2024</span></h3>
                  <dl>
                    <dt>
                      更新矢量地图注记、影像地图注记。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>2月<span>2024</span></h3>
                  <dl>
                    <dt>
                      更新了2024年兴趣点（POI）数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo">2023年</a></h2>
                <li class="green">
                  <h3>9月<span>2023</span></h3>
                  <dl>
                    <dt>
                      更新江阴高铁站影像和矢量地图数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>6月<span>2023</span></h3>
                  <dl>
                    <dt>
                      更新矢量地图注记、影像地图注记。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>6月<span>2023</span></h3>
                  <dl>
                    <dt>
                      更新了2023年兴趣点（POI）数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo">2022年</a></h2>
                <li class="green">
                  <h3>10月<span>2022</span></h3>
                  <dl>
                    <dt>
                      更新了审图号为“苏B(2022)006号”。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>6月<span>2022</span></h3>
                  <dl>
                    <dt>
                      更新矢量地图注记、影像地图注记。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>6月<span>2022</span></h3>
                  <dl>
                    <dt>
                      更新了2022年兴趣点（POI）数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo">2021年</a></h2>
                <li class="green">
                  <h3>5月<span>2021</span></h3>
                  <dl>
                    <dt>
                      天地图网站一体化建设。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>10月<span>2021</span></h3>
                  <dl>
                    <dt>
                      更新了审图号为“苏B(2021)030号”。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo">2020年</a></h2>

                <li class="green">
                  <h3>11月<span>2020</span></h3>
                  <dl>
                    <dt>
                      更新了审图号为“图苏B(2020)12号”。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>11月<span>2020</span></h3>
                  <dl>
                    <dt>
                      更新矢量地图注记、影像地图注记。
                      <span></span>
                    </dt>
                  </dl>
                </li>
                <li class="green">
                  <h3>12月<span>2020</span></h3>
                  <dl>
                    <dt>
                      更新了2020年兴趣点（POI）数据。
                      <span></span>
                    </dt>
                  </dl>
                </li>
              </ul>
              <ul>
                <h2 class="first"><a href="#nogo"></a></h2>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_bg container">
        <div class="footer">
          <foot />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import headV from "./head.vue";
import foot from "./footer.vue";
import "../logupdate/js/jquery";
import "../logupdate/js/main";
import { ref, onMounted, nextTick } from "vue";
// 核心修复：用nextTick+延迟，确保在Vue DOM更新完成后执行
onMounted(() => {
  nextTick(() => {
    // 延迟时间加长，确保Vue完全渲染并完成响应式绑定
    setTimeout(() => {
      if (window.systole) {
        window.systole();
      }
    }, 500);
  });
});
</script>
<style>
@import url("../logupdate/css/history.css");
</style>